import { Select, SelectProps } from 'antd';

export enum PresumedCreditType {
  NO_PRESUMED_CREDIT = 'NO_PRESUMED_CREDIT',
  FINAL_CONSUMER_GOODS = 'FINAL_CONSUMER_GOODS',
  CAPITAL_GOODS = 'CAPITAL_GOODS',
  INTERMEDIATE_GOODS = 'INTERMEDIATE_GOODS',
  IT_GOODS_AND_OTHERS_DEFINED_IN_LEGISLATION = 'IT_GOODS_AND_OTHERS_DEFINED_IN_LEGISLATION',
}

export const PresumedCreditTypeLabel: Record<PresumedCreditType, string> = {
  NO_PRESUMED_CREDIT: 'Sem crédito Presumido',
  FINAL_CONSUMER_GOODS: 'Bens de Consumo Final',
  CAPITAL_GOODS: 'Bens de Capital',
  INTERMEDIATE_GOODS: 'Bens Intermediários',
  IT_GOODS_AND_OTHERS_DEFINED_IN_LEGISLATION:
    'Bens de Informática e Outros Definidos na Legislação',
};

export default function SelectIbsZfmPresumedCreditType(
  props: Omit<SelectProps, 'options'>,
) {
  return (
    <Select
      {...props}
      options={Object.values(PresumedCreditType).map((value) => ({
        value: value,
        label: PresumedCreditTypeLabel[value],
      }))}
    />
  );
}
